import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const usePageStyles = makeStyles(() => {
  return createStyles({
    container: {
      minHeight: '100vh',
    },
  });
},
);

export default usePageStyles;
